import React from 'react';
import AiSearchPage from './components/AiSearchPage';
import {
    OutreachCandidatePopoutContext,
    useOutreachCandidatePopoutContextProvider,
} from './components/ShortlistedList/Outreach/OutreachContext';
import ShortlistedPageContent from './components/ShortlistedList/ShortlistedPageContent';
import {
    ShortlistedListContext,
    useShortlistedListContextProvider,
} from './components/ShortlistedList/utils/ShortlistedListContext';
import {
    AiSearchProfilePopoutContext,
    useAiSearchProfilePopoutContextProvider,
} from './components/AiSearchProfilePopout/AiSearchProfilePopoutContext';

const ShortlistedAiSearchPage = () => {
    return (
        <AiSearchPage>
            <AiSearchProfilePopoutContext.Provider value={useAiSearchProfilePopoutContextProvider()}>
                <ShortlistedListContext.Provider value={useShortlistedListContextProvider()}>
                    <OutreachCandidatePopoutContext.Provider value={useOutreachCandidatePopoutContextProvider()}>
                        <ShortlistedPageContent />
                    </OutreachCandidatePopoutContext.Provider>
                </ShortlistedListContext.Provider>
            </AiSearchProfilePopoutContext.Provider>
        </AiSearchPage>
    );
};

export default ShortlistedAiSearchPage;
